import * as React from "react";
import { useLocation, Navigate, Routes, Route } from "react-router-dom";
import { BillingAccountCreateWithId } from "./account/createWithId";
import { BillingAccountCreateFirstWithId } from "./account/createFirstWithId";

const BillingFallback: React.FC = () => {
  const { pathname } = useLocation();

  // Redirect legacy billing create URLs to new home-based paths
  if (pathname.startsWith(`/billing/account/-createfirst`)) {
    return <Navigate to={`/home/account/-create`} />;
  }
  if (pathname.startsWith(`/billing/account/-create`)) {
    return <Navigate to={`/home/account/-create`} />;
  }

  return null;
};

export const BillingRoute: React.FC = () => {
  return (
    <Routes>
      {/* Backward-compatible referral ID routes matching master's URL pattern */}
      <Route path="account/id/:id/-create" element={<BillingAccountCreateWithId />} />
      <Route path="account/id/:id/-createfirst" element={<BillingAccountCreateFirstWithId />} />
      <Route path="*" element={<BillingFallback />} />
    </Routes>
  );
};
